import { render, staticRenderFns } from "./ConfirmacaoLogin.vue?vue&type=template&id=172723a6&"
import script from "./ConfirmacaoLogin.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports